import { useEffect, useRef } from 'react';

export const CodeRain = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');

    // Set canvas size
    const resizeCanvas = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    resizeCanvas();
    window.addEventListener('resize', resizeCanvas);

    // Code characters - mix of code symbols and keywords
    const chars = '{}[]()<>=/;:const let var function return if else for while import export async await => !== === && || + - * / % true false null undefined class new this props state React Vue Angular CSS HTML JavaScript TypeScript Node API REST GraphQL MongoDB SQL JSON XML HTTP HTTPS GET POST PUT DELETE npm yarn git push pull merge commit deploy build test debug 01';
    const charArray = chars.split('');

    const fontSize = 16;
    const columns = Math.floor(canvas.width / fontSize);

    // Array to track y position of each column
    const drops = Array(columns).fill(1);

    // Random starting positions
    for (let i = 0; i < drops.length; i++) {
      drops[i] = Math.random() * -100;
    }

    const draw = () => {
      // Semi-transparent black to create fade effect
      ctx.fillStyle = 'rgba(5, 5, 5, 0.05)';
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      // Electric blue color with varying opacity
      ctx.font = `${fontSize}px 'JetBrains Mono', monospace`;

      for (let i = 0; i < drops.length; i++) {
        // Random character
        const char = charArray[Math.floor(Math.random() * charArray.length)];

        // Varying blue shades - MORE VISIBLE
        const opacity = Math.random() * 0.6 + 0.3;
        const isHighlight = Math.random() > 0.95;
        
        if (isHighlight) {
          ctx.fillStyle = `rgba(0, 87, 255, ${opacity + 0.4})`;
          ctx.shadowColor = '#0057FF';
          ctx.shadowBlur = 10;
        } else {
          ctx.fillStyle = `rgba(0, 87, 255, ${opacity})`;
          ctx.shadowBlur = 0;
        }

        ctx.fillText(char, i * fontSize, drops[i] * fontSize);

        // Reset shadow
        ctx.shadowBlur = 0;

        // Reset drop to top with random delay
        if (drops[i] * fontSize > canvas.height && Math.random() > 0.975) {
          drops[i] = 0;
        }

        // Move drop down
        drops[i] += 0.5 + Math.random() * 0.5;
      }
    };

    const interval = setInterval(draw, 50);

    return () => {
      clearInterval(interval);
      window.removeEventListener('resize', resizeCanvas);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      className="absolute inset-0 z-0"
      style={{ opacity: 0.8 }}
    />
  );
};
